<template>
  <div>
    <a-form-model label-width="110px" class="SiftActivity UniformCss">
      <el-row>
        <el-col :span="4">
          <a-form-model-item label="活动名称/编码">
            <a-input v-model="data.planCodeOrName" placeholder="输入活动名称/计划编码" clearable />
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="预算类型">
            <a-select v-model="data.budgetTypeCode">
              <a-select-option v-for="item in budgetData" :key="item.valueCode" :value="item.valueCode" >{{item.valueName}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="一级来源：">
            <a-select v-model="data.oneLevelCode" filterable clearable @change="oneSourceChange">
              <a-select-option
                v-for="item in oneSourceList"
                :key="item.sourceCode"
                :value="item.sourceCode"
              >{{item.sourceName}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="二级来源：">
            <a-select v-model="data.twoLevelCode" filterable clearable @change="twoSourceChange">
              <a-select-option
                v-for="item in twoSourceList"
                :key="item.sourceCode"
                :value="item.sourceCode"
                >{{item.sourceName}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="三级来源：">
            <a-select v-model="data.threeLevelCode" filterable clearable>
              <a-select-option v-for="item in threeSourceList" :key="item.sourceCode" :value="item.sourceCode">{{item.sourceName}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </el-col>
        <el-col v-if="show" :span="4">
          <a-form-model-item label="状态">
            <a-select v-model="data.planStatus" placeholder="请选状态">
              <a-select-option v-for="(activePlanStatu, index) in SelectLists.activePlanStatus" :key="index" :value="activePlanStatu.code" >{{activePlanStatu.value}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </el-col>
      </el-row>
    </a-form-model>
  </div>
</template>
<script>
import { getActsubtype, queryValueTypeByCode } from '@/api/activity' // 活动类接口
import { getSourceSelectList } from '@/api/base-data'

export default {
  name: 'SiftActivity',
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      subclassData: [],
      isotopicCarrierData: [],
      budgetData: [],
      SelectLists: {}
    }
  },
  computed: {
    oneSourceList() {
      return this.$store.state.actPlanListPage.sourceList.oneSourceList
    },
    twoSourceList() {
      return this.$store.state.actPlanListPage.sourceList.twoSourceList
    },
    threeSourceList() {
      return this.$store.state.actPlanListPage.sourceList.threeSourceList
    }
  },
  created() {
    this.getBudgettype() // 预算类型
    // 下拉框获取
    this.SelectListsFun()
    // 获取活动来源下拉框数据
    this.getFiveSource(1)
  },
  beforeMount() {},
  mounted() {},
  methods: {
    SelectListsFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['activePlanStatus']).then(v => {
        this.SelectLists = v
      })
    },

    getActsubtype(bigtypeid) {
      this.data.subtypeid = null
      this.getActcarrier(this.data.subtypeid)
      this.subclassData = []
      if (bigtypeid) {
        getActsubtype({ bigtypeid }).then(res => {
          if (res.code === 1 && res.data) {
            this.subclassData = res.data
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    // 获取预算类型
    getBudgettype() {
      queryValueTypeByCode({ typeCode: 'budgetary', page: 1, limit: 999 }).then(res => {
        if (res.code === 1) {
          this.budgetData = res.data.list
        }
      })
    },
    // 获取活动来源下拉框数据
    getFiveSource(level, parentId) {
      const data = {
        level: level,
        parentId: null
      }
      if (parentId) {
        data.parentId = parentId
      }
      getSourceSelectList(data).then(res => {
        if (res.code === 1) {
          this.handleSelectList(level, res.data)
        }
      })
    },
    // 将来源分为一级二级三级，对应下拉框
    handleSelectList(level, data) {
      const param = {
        level: level,
        list: data
      }

      this.$store.commit('actPlanListPage/updateSourceList', param)
    },
    oneSourceChange(value) {
      if (value) {
        const data = this.oneSourceList.find(item => item.sourceCode === value)
        this.getFiveSource(2, data.sourceId)
      } else {
        // 清空2，3级来源列表
        this.handleSelectList(2, [])
        this.handleSelectList(3, [])
      }
    },
    twoSourceChange(value) {
      if (value) {
        const data = this.twoSourceList.find(item => item.sourceCode === value)
        this.getFiveSource(3, data.sourceId)
      } else {
        // 清空3级来源列表
        this.handleSelectList(3, [])
      }
    }
  }
}
</script>
<style lang="less">
.SiftActivity {
  .a-form-model-item {
    display: inline-block;
  }
}
</style>
